
import { toast } from "sonner";

interface ToastOptions {
  description?: string;
  duration?: number;
}

const defaultToastOptions = {
  duration: 3000,
  className: "rounded-lg border-2 border-[#34375B]/10",
  action: {
    label: "✕",
    onClick: () => toast.dismiss()
  }
};

export const showToast = {
  success: (title: string, options?: ToastOptions) => {
    toast.success(title, {
      ...defaultToastOptions,
      ...options,
    });
  },
  error: (title: string, options?: ToastOptions) => {
    toast.error(title, {
      ...defaultToastOptions,
      ...options,
    });
  },
  info: (title: string, options?: ToastOptions) => {
    toast.info(title, {
      ...defaultToastOptions,
      ...options,
    });
  },
  warning: (title: string, options?: ToastOptions) => {
    toast.warning(title, {
      ...defaultToastOptions,
      ...options,
    });
  },
};
